import { createContext, useContext, type ReactNode } from 'react';
import { useMobileUI } from './useMobileUI';

interface DeviceContextValue {
  isMobileUI: boolean;
  isDeviceReady: boolean;
}

const DeviceContext = createContext<DeviceContextValue>({
  isMobileUI: false,
  isDeviceReady: false,
});

export function DeviceProvider({ children }: { children: ReactNode }) {
  const { isMobileUI, isDeviceReady } = useMobileUI();
  return (
    <DeviceContext.Provider value={{ isMobileUI, isDeviceReady }}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDevice(): DeviceContextValue {
  return useContext(DeviceContext);
}
